(ns frontend.ui.component.lp-portal.report.body.voima.fund.pdf-pages.summary-and-figures
  (:require
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.report.component.block-table.pdf-view :as block-table-pdf]
   [frontend.ui.component.lp-portal.report.component.overview-figures.pdf-view :as overview-figures-pdf]
   [frontend.ui.component.lp-portal.voima-components.pdf.column.view :as column]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.lp-portal.voima-components.pdf.card.view :refer [card]]
  ))

(defn- executive-summary-figures
  [{:keys [executive-summary-figures]}]
  (block-table-pdf/table executive-summary-figures))

(defn summary-and-figures-page
  [data]
  (let [{:keys [overview-figures executive-summary]} data]
    (page/page
     (page/third-column-background-full-height-not-rounded)
     (page/page-title-with-line {:fund-name (:fund-name data) :page-title "Overview" :toc-item true})
     (column/columns-2-to-1
      (card
       nil
       (overview-figures-pdf/table (:figures overview-figures) 4)
       (card
        ""
        (text-content/rich-content (->> executive-summary
                                        :case-overview
                                        :rich-content))))
      (card
       nil
       (executive-summary-figures executive-summary)
       (text-content/optional-footer (:executive-summary-figures executive-summary)))))))
